export const fileCategories = ['Todos', 'Documentos', 'PDFs', 'Fotos', 'Videos', 'Otros'] as const
export type FileCategory = typeof fileCategories[number]
export function fileCategory(name: string): FileCategory {
  const ext = name.split('.').pop()?.toLowerCase() || ''
  if (ext === 'pdf') return 'PDFs'
  if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif', 'bmp', 'tif', 'tiff', 'avif', 'svg'].includes(ext)) return 'Fotos'
  if (['mp4', 'mov', 'm4v', 'webm', 'avi', 'mkv', '3gp', 'mpeg', 'mpg'].includes(ext)) return 'Videos'
  if (['doc', 'docx', 'odt', 'rtf', 'txt', 'md', 'xls', 'xlsx', 'ods', 'csv', 'ppt', 'pptx', 'odp'].includes(ext)) return 'Documentos'
  return 'Otros'
}
